import { MutationType } from '@tencent/slide-sdk-pb-model';
import { cloneDeep } from '../utils/clone-deep';
import type { ISmartArtData } from '../data';
import type {
    IValidMutationData,
    IValidSetDiagramDataMutationData,
    IValidSetDiagramDrawingMutationData,
    IValidSetDiagramsMutationData,
} from '../mutation/base';
import type { KeyframeContext } from './keyframe-context.interface';
import type { MarkRequired } from 'ts-essentials';

export function getSmartArtKeyframe(
    graphic: ISmartArtData,
    context: MarkRequired<KeyframeContext, 'page'>,
): IValidMutationData[] {
    const mutations: IValidMutationData[] = [];
    const pageId = context.idFactory(context.page.id);
    const shapeId = context.idFactory(graphic.id);

    const diagram = cloneDeep(graphic.diagram);
    if (diagram.drawing) {
        const setDiagramDrawing = {
            type: MutationType.SetDiagramDrawing,
            shapeId,
            pageId,
            drawing: diagram.drawing,
        } satisfies IValidSetDiagramDrawingMutationData;
        mutations.push(setDiagramDrawing);
    }

    if (diagram.dataModel) {
        const setDiagramDataModel = {
            type: MutationType.SetDiagramData,
            shapeId,
            pageId,
            dataModel: diagram.dataModel,
        } satisfies IValidSetDiagramDataMutationData;
        mutations.push(setDiagramDataModel);
    }

    if (diagram.layoutDef || diagram.colorDefs || diagram.styleDef) {
        const setDiagrams = {
            type: MutationType.SetDiagrams,
            shapeId,
            pageId,
            layoutDef: diagram.layoutDef,
            colorDef: diagram.colorDef,
            styleDef: diagram.styleDef,
        } satisfies IValidSetDiagramsMutationData;
        mutations.push(setDiagrams);
    }

    return mutations;
}
